// extracted by mini-css-extract-plugin
export var section = "banner-module--section--29-jZ";
export var jsAnimInit = "banner-module--jsAnimInit--1b4sb";
export var descripton = "banner-module--descripton--1GFBH";
export var image = "banner-module--image--3yS5H";
export var inner = "banner-module--inner--1_JJj";